import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import ConversionGroup from "models/groups/ConversionGroup";

class MetricConversion extends MetricBase {
    constructor() {
        super({
            field: "metric_conversion_rate",
            defaultVisibility: false,
            unit: EmptyUnit,
            chartName: i18n.t("metrics.tripadvisor.conversion.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.conversion.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.conversion.tooltip"),
            group: new ConversionGroup(),
        });
    }
}
export default MetricConversion

